import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Instagram, Facebook } from "lucide-react";
import { CONTACT_INFO } from "../data";
import { useLanguage } from "./LanguageContext";

export default function Footer() {
  const { lang } = useLanguage();

  const followUs = lang === "da" ? "Følg os" : "Follow us";

  return (
    <footer className="relative border-t border-stone-200 bg-[#FCF9F5] text-stone-600 font-sans-custom">
      <div className="mx-auto max-w-7xl px-6 py-12 md:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-8">
          {/* Brand Column */}
          <div className="flex items-center gap-4">
            <Link to={lang === "da" ? "/da" : "/en"} className="flex items-center gap-3 group">
              <div className="relative flex h-20 w-20 items-center justify-center transition-all duration-300 rounded-none">
                <img
                  src="https://assets.auxodev.dk/assets/47342516-e670-4852-ad73-fdec3014e752/2e87f6a0-71a0-4e77-a6b8-93a81e3adb0a.png"
                  alt="Equinesport Heineking Logo"
                  className="h-20 w-20 object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </Link>
          </div>

          {/* Socials & Copyright */}
          <div className="flex flex-col sm:items-end gap-4">
            <div className="flex items-center gap-3">
              <span className="text-[10px] font-semibold uppercase tracking-widest text-stone-900 font-sans-custom mr-2">
                {followUs}
              </span>
              <a
                href={CONTACT_INFO.socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-stone-200 bg-white text-stone-600 hover:border-stone-800 hover:text-stone-900 transition-all duration-300 rounded-none shadow-sm"
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href={CONTACT_INFO.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-stone-200 bg-white text-stone-600 hover:border-stone-800 hover:text-stone-900 transition-all duration-300 rounded-none shadow-sm"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={CONTACT_INFO.socials.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-stone-200 bg-white text-stone-600 hover:border-stone-800 hover:text-stone-900 transition-all duration-300 rounded-none shadow-sm"
                aria-label="YouTube"
              >
                <Youtube className="h-4 w-4" />
              </a>
            </div>
            <div className="text-[10px] text-stone-400 uppercase tracking-widest font-semibold font-sans-custom">
              © {new Date().getFullYear()} Equinesport. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
